// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6694376d","453":"b5d749dd","455":"9a45ecbe","977":"a2f715a0"}[chunkId] + ".chunk.js";
};